import typeOf  from '../../helpers/typeOf';
import {
    metrics
} from './config';

const getParams = (keys) => {
    if (typeOf.isObject(keys)) {
        return metrics[keys.metricKey][keys.key] || {};
    }

    return metrics[keys] || {};
};

const Helpers = {
    getParams
};

export default Helpers;
